import React from 'react';
import { Paper, Box, TextField, Select, MenuItem, FormControl, InputLabel, SelectChangeEvent } from '@mui/material';

/**
 * Filter interface
 */
export interface FrameworkFiltersState {
  search: string;
  status: 'all' | 'active' | 'draft' | 'archived';
}

/**
 * Props interface
 */
interface FrameworkFiltersProps {
  filters: FrameworkFiltersState;
  onFilterChange: (filters: Partial<FrameworkFiltersState>) => void;
}

/**
 * Framework Filters Component
 * 
 * Provides filtering options for the FrameworkList component
 */
export default function FrameworkFilters({ filters, onFilterChange }: FrameworkFiltersProps) {
  /**
   * Handle search input change
   */
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange({ search: event.target.value });
  };

  /**
   * Handle status select change
   */
  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    onFilterChange({ status: event.target.value as any });
  };

  /**
   * Render component
   */
  return (
    <Paper elevation={0} variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2}>
        <TextField
          label="Search Frameworks"
          variant="outlined"
          size="small"
          fullWidth
          value={filters.search}
          onChange={handleSearchChange}
          placeholder="Search by name or description"
        />
        
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel id="status-filter-label">Status</InputLabel>
          <Select
            labelId="status-filter-label"
            value={filters.status}
            label="Status"
            onChange={handleStatusChange}
          >
            <MenuItem value="all">All Statuses</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="draft">Draft</MenuItem>
            <MenuItem value="archived">Archived</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Paper>
  );
}
